import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class DocumentsPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            documents: [],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    componentDidMount() {
        this.getDocuments()
    }

    handleChange(e){
        this.setState({documents: [], search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getDocuments();
        });
    }
    async getMimes() {
        const res = await axios.get('/api/mimes')
        this.setState({mimes: res.data})
    }
    traducirPalabra = (palabra)=>{ 
        const { lang } = this.context;  
        if(palabra == '(es)'){
            return '';
        }
        return lang.get('messages.'+palabra.toLowerCase().replace(/\s+/g, '_').replace(/\s+/g, '_').replace(/[()]/g, '').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/,/g, ''))
    }
    translatePeriod = (texto) => {
        if (texto === null || texto === undefined) {
            return ''; 
            }
            const palabras = texto.split(/\s+/);
            const textoTraducido = palabras.map((palabra) => this.traducirPalabra(palabra)).join(' ');
            return textoTraducido;
    }
    async getDocuments(){
        var url = '/api/documents';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({documents: data, total: res.data.total});
    }

    render() {
        const { lang } = this.context; 
        return (
            <>
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-6">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.plantillas_de_documentos')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles')}</span>
                    </h3>
                    <div className="card-toolbar">
                        {this.props.dashboard=="false" &&
                            <div className="input-icon mb-4">
                                <input
                                    style={{width: '400px'}}
                                    onChange={this.handleChange}
                                    name="search"
                                    type="text"
                                    className="form-control"
                                    placeholder={lang.get('messages.buscar_documentos')} />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                        }
                        { this.props.top != null && this.props.dashboard=="true" &&
                            <ul className="nav nav-pills nav-pills-sm nav-dark">
                                <li className="nav-item ml-0">
                                    <a href="/documents" className="btn btn-icon-primary btn-clean btn-hover-light-primary btn-sm btn-icon">
                                        <span className="svg-icon svg-icon-lg">
                                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" strokeWidth="1">
                                                    <rect x="14" y="9" width="6" height="6" rx="3" fill="black" />
                                                    <rect x="3" y="9" width="6" height="6" rx="3" fill="black" fillOpacity="0.7" />
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        }
                    </div>
                </div>
                <div className="card-body pt-5">
                {this.props.dashboard=="false" &&
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="border-0">{lang.get('messages.nombre')}</th>
                                <th className="border-0">{lang.get('messages.frecuencia')}</th>
                                <th className="border-0">{lang.get('messages.formatos')}</th>
                                <th>Categoria</th>
                                <th className="border-0"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.documents.map((o, i) => {
                        return <tr>
                            <td class=" pl-0 py-5 text-dark-75 font-weight-bolder font-size-lg d-flex align-items-center gap-1">
                                <i className="text-primary flaticon2-files-and-folders" style={{color:'inherit'}}></i>
                                <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.title}</a>
                                {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                            </td>
                            <td><span className="text-dark-50 mb-1 font-size-lg ">
                                {this.translatePeriod(o.period)}   
                                </span></td>
                            <td>
                            <span className="text-muted font-weight-bold">
                                        {
                                            o.mimes.map((mime, i, {length}) => {
                                                if (length - 1 === i) {
                                                    return mime.mime.toUpperCase()
                                                } else {
                                                    return mime.mime.toUpperCase() + ', '
                                                }
                                            })
                                        }
                                    </span>
                            </td>
                            <td>
                                <span className="text-muted font-weight-bold">  {o.type.category.name}</span> 
                            </td>
                            <td>
                            <a href={"/documents/" + o.id + "/edit"}  style={{width:'10%'}}>
                                <button className="btn btn-icon btn-light btn-xs">
                                    <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                </button>
                            </a>
                            </td>
                            </tr>
                            }
                        )}
                        </tbody>
                    </table>
                    }
                    {this.props.dashboard=="true" &&
                        this.state.documents.map((o, i) => {
                        return <div key={i}>
                        <div className="d-flex align-items-center py-2">
                            <i className={"flaticon2-files-and-folders icon-lg mr-3 " + (o.active==0 ? "text-dark-50" : "text-primary")}></i>
                            <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2"  style={{width:'40%'}}>
                                <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.title}</a>
                                {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                            </div>
                            {this.props.dashboard=="false" &&
                                <>
                                    <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2"  style={{width:'30%'}}>
                                        <span className="text-dark-50 mb-1 font-size-lg ">{o.period}</span>
                                    </div>
                                    <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2"  style={{width:'20%'}}>
                                    <span className="text-muted font-weight-bold">
                                        {

                                            o.mimes.map((mime, i, {length}) => {
                                                if (length - 1 === i) {
                                                    return mime.mime.toUpperCase()
                                                } else {
                                                    return mime.mime.toUpperCase() + ', '
                                                }
                                            })
                                        }
                                    </span>
                                    </div>
                                </>
                            }
                            <a href={"/documents/" + o.id + "/edit"}  style={{width:'10%'}}>
                                <button className="btn btn-icon btn-light btn-xs">
                                    <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                </button>
                            </a>
                        </div>
                    </div>
                    })
                }
                </div>
                {this.state.total > this.state.maxRecords && this.props.dashboard=="false" &&
                    <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }

            </div>
            </>
        );
    }
}

export default DocumentsPanel;

if (document.getElementById('DocumentsPanel')) {
    ReactDOM.render(<DocumentsPanel />, document.getElementById('DocumentsPanel'));
}
